import apiFactory from '../../../api/factory';
import {VehiclePlanTasksType} from "./GetVehiclePlanTasks";

const {call} = apiFactory();
const resource = 'vehicle/maintenance/task'
export const UpdateVehiclePlanTasks = (id: number, plan): Promise<VehiclePlanTasksType> => {
    return call(plan,`api/v2/${resource}/${id}`,'put')
}